<template>
  <v-card class="rsu pa-4" style="border-radius: 10px">
    <div style="display: flex; justify-content: space-between; align-items: center">
      <!-- <div class="headline primary--text mb-6 bold7 fs-24">{{ $t('เพิ่มข้อมูล') }}</div> -->
      <Typography h2 bold :label="$t('เพิ่มข้อมูล')" />
      <v-btn @click="$emit('close')" icon><v-icon>close</v-icon></v-btn>
    </div>
    <div class="pt-2">
      <!-- <div>ประเภท</div> -->
      <Typography h5 semiBold label="ประเภท" />
      <div class="form-control" :class="{ 'has-error': errors.has('type') }">
        <input
          v-validate="'required'"
          name="type"
          v-model="input.type"
          type="text"
          class="depainput rsu"
        />
        <span
          style="font-size: 14px; color: red"
          class="text-error mb-2"
          v-show="errors.has('type')"
          >{{ errors.first('type') }}</span
        >
      </div>
      <!-- <div>การตรวจสอบ</div> -->
      <Typography h5 semiBold label="การตรวจสอบ" />
      <div class="form-control" :class="{ 'has-error': errors.has('verification') }">
        <DropdownMenu
          v-validate="'required'"
          name="verification"
          :options="typeOptions"
          v-model="input.verification"
        >
          <input
            readonly
            :value="input.verification"
            type="text"
            class="color-mediumBlue depainput rsu"
          />
        </DropdownMenu>
        <span
          style="font-size: 14px; color: red"
          class="text-error mb-2"
          v-show="errors.has('verification')"
          >{{ errors.first('verification') }}</span
        >
      </div>
      <!-- <div>กรณีที่อนุมัติ</div> -->
      <Typography h5 semiBold label="กรณีที่อนุมัติ" />
      <div class="form-control" :class="{ 'has-error': errors.has('allow case') }">
        <DropdownMenu
          v-validate="'required'"
          name="allow case"
          :options="caseOptions"
          v-model="input.allow_case"
          :colorRed="true"
        >
          <input
            :colorRed="true"
            readonly
            :value="input.allow_case"
            type="text"
            class="color-error depainput rsu"
          />
        </DropdownMenu>
        <span
          style="font-size: 14px; color: red"
          class="text-error mb-2"
          v-show="errors.has('allow case')"
          >{{ errors.first('allow case') }}</span
        >
      </div>
      <!-- <div>สถานะ</div> -->
      <Typography h5 semiBold label="สถานะ" />
      <div class="form-control" :class="{ 'has-error': errors.has('Status') }">
        <DropdownMenu
          v-validate="'required'"
          name="Status"
          :options="statusOptions"
          v-model="input.status"
        >
          <input
            readonly
            :value="input.status"
            type="text"
            class="color-mediumBlue depainput rsu"
          />
        </DropdownMenu>
        <span
          style="font-size: 14px; color: red"
          class="text-error mb-2"
          v-show="errors.has('Status')"
          >{{ errors.first('Status') }}</span
        >
      </div>
      <div class="pt-3" style="display: flex;justify-content: center;">
        <Button outline :label="$t('cancel')" @click="$emit('close')" />
        <Button depressed :label="$t('Save')" @click="onSave" />
      </div>
    </div>
  </v-card>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import Typography from '@/components/elements/Typography.vue'
import Button from '@/components/elements/Button.vue'
export default {
  data() {
    return {
      input: { type: '', allow_case: '', verification: '', status: null },
      caseOptions: [
        'CASE 1: ERROR มีข้อมูลนี้อยู่แล้ว กรุุณากรอกใหม่อีกครั้ง',
        'CASE 2: NOTIFY ให้คนที่ลงทะเบียนคนแรก Approve',
        'CASE 3: Add เข้าองค์กรอัตโนมัติ',
      ],
      statusOptions: ['บุคคลธรรมดา', 'นิติบุคคล'],
      loading: false,
      typeOptions: ['มี Tax ID', 'ไม่มี Tax ID', 'บุคคลธรรมดา', 'เกษตรกร'],
    }
  },
  components: {
    DropdownMenu,
    Typography,
    Button,
  },
  computed: {
    ...mapGetters(['selectedBot']),
  },
  methods: {
    async onSave() {
      let result = await this.$validator.validateAll()
      if (!result || !this.input.allow_case) {
        return false
      }
      var data = {
        type: this.input.type,
        verification: this.input.verification,
        allow_case: this.input.allow_case,
        status: this.input.status,
        pageid: this.selectedBot.pageid,
      }
      this.loading = true
      api.postdepamembertype(data, (err, response) => {
        this.loading = false
        this.input = { type: '', allow_case: '', verification: '', status: null }
        this.$emit('onSave')
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/memberType/MemberTypeAdd.vue